import { errorLogSummary } from '@/services/api/error-parser';
import type { KioskAnalyticsProperties } from './kiosk-analytics';

export function kioskErrorProperties(
  error: unknown,
  phase: 'photo' | 'generation' | 'camera'
): KioskAnalyticsProperties {
  const summary = errorLogSummary(error);
  const status = summary.status;
  const cause = error instanceof Error ? error.cause : undefined;
  const original = errorLogSummary(cause ?? error);
  const code =
    typeof summary.code === 'string' &&
    /^[A-Z][A-Z0-9_]{0,63}$/.test(summary.code)
      ? summary.code
      : undefined;
  const name = original.name ?? summary.name;
  let category = 'unknown';
  if (name === 'AbortError') category = 'cancelled';
  else if (
    name === 'TimeoutError' ||
    (code && /TIMEOUT|TIMED_OUT/.test(code)) ||
    status === 408 ||
    status === 504
  )
    category = 'timeout';
  else if (name === 'NotAllowedError' || name === 'PermissionDeniedError')
    category = 'camera_permission';
  else if (
    phase === 'camera' &&
    ['NotFoundError', 'NotReadableError', 'OverconstrainedError'].includes(
      name ?? ''
    )
  )
    category = 'camera_unavailable';
  else if (status === 429) category = 'rate_limited';
  else if (status === 401 || status === 403) category = 'authorization';
  else if (status && status >= 500) category = 'provider';
  else if (status && status >= 400) category = 'validation';
  else if (
    status === 0 ||
    (code && /^(?:NETWORK|ECONN|ENET|EHOST)/.test(code)) ||
    (name === 'TypeError' &&
      /fetch|network|load failed/i.test(original.message ?? ''))
  )
    category = 'network';
  return {
    error_category: category,
    error_code: code,
    http_status: status,
    failure_phase: phase,
  };
}
